export const getNewPatientPriorityProps = (fieldValue: string | null) => {
  const normalizedValue = fieldValue?.toLowerCase().trim();

  // Handle priority cases - blue badge (highest priority)
  if (normalizedValue === 'priority') {
    return {
      fieldValue: 'Priority',
      fieldValueBgColor: 'background.blue100',
      fieldValueTextColor: 'text.primary',
    };
  }

  // Handle positive cases - green badge
  if (normalizedValue === 'yes') {
    return {
      fieldValue: 'Yes',
      fieldValueBgColor: 'background.green100',
      fieldValueTextColor: 'text.primary',
    };
  }

  // Handle limited cases - yellow badge
  if (normalizedValue === 'limited') {
    return {
      fieldValue: 'Limited',
      fieldValueBgColor: 'background.yellow100',
      fieldValueTextColor: 'text.primary',
    };
  }

  // Handle negative cases - red badge
  if (normalizedValue === 'no') {
    return {
      fieldValue: 'No',
      fieldValueBgColor: 'background.red100',
      fieldValueTextColor: 'text.primary',
    };
  }

  // Handle none cases - gray badge (neutral/no status)
  if (normalizedValue === 'none') {
    return {
      fieldValue: 'None',
      fieldValueBgColor: 'background.gray100',
      fieldValueTextColor: 'text.primary',
    };
  }

  // Handle empty string value - treat as "None"
  if (normalizedValue === '' || !normalizedValue) {
    return {
      fieldValue: 'None',
      fieldValueBgColor: 'background.gray100',
      fieldValueTextColor: 'text.primary',
    };
  }

  // Handle any other unexpected values - gray badge
  return {
    fieldValue: fieldValue || 'Unknown',
    fieldValueBgColor: 'background.gray100',
    fieldValueTextColor: 'text.primary',
  };
};